import { useEffect } from 'react';

export default (fn, hook = useEffect) => hook(() => fn && fn(), []);
